import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProjetsClients, refuseProjet } from "../../redux/actions/projetClientActions";
import ProjectCard from "../ProjectCard";

const ProjetsClientsAdminDashboard = () => {
    const { user, token } = useSelector((state) => state.auth);
    const projetsClients = useSelector((state) => state.projetClient.listProjets);
    const dispatch = useDispatch();

    // index du projet affiché
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (!user || !token) return;
        dispatch(fetchProjetsClients(token));
    }, [user, token, dispatch]);

    // Quand la liste change on réinitialise l’index
    useEffect(() => {
        if (projetsClients.length > 0) {
            setCurrentIndex(0);
        }
    }, [projetsClients]);

    const nextProject = () => {
        if (currentIndex < projetsClients.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const prevProject = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    if (projetsClients.length === 0) {
        return <p>Aucun projet client actuellement</p>;
    }

    const currentProject = projetsClients[currentIndex];

    return (
        <div style={{ textAlign: "center" }}>

            {/* Navigation */}
            <div style={{ marginBottom: "15px", marginTop: "20px", display: "flex", justifyContent: "center", gap: "15px" }}>

                {/* Bouton Précédent */}
                <button
                    onClick={prevProject}
                    disabled={currentIndex === 0}
                    style={{
                        padding: "12px 25px",
                        backgroundColor: currentIndex === 0 ? "#d3d3d3" : "#2563eb",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        fontSize: "15px",
                        cursor: currentIndex === 0 ? "not-allowed" : "pointer",
                        boxShadow: currentIndex === 0 ? "none" : "0 3px 6px rgba(0,0,0,0.15)",
                        transition: "0.2s",
                    }}
                    onMouseOver={(e) => {
                        if (currentIndex !== 0) e.target.style.backgroundColor = "#1e4fcf";
                    }}
                    onMouseOut={(e) => {
                        if (currentIndex !== 0) e.target.style.backgroundColor = "#2563eb";
                    }}
                >
                    ◀ Projet précédent
                </button>

                {/* Bouton Suivant */}
                <button
                    onClick={nextProject}
                    disabled={currentIndex === projetsClients.length - 1}
                    style={{
                        padding: "12px 25px",
                        backgroundColor:
                            currentIndex === projetsClients.length - 1 ? "#d3d3d3" : "#2563eb",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        fontSize: "15px",
                        cursor:
                            currentIndex === projetsClients.length - 1 ? "not-allowed" : "pointer",
                        boxShadow:
                            currentIndex === projetsClients.length - 1
                                ? "none"
                                : "0 3px 6px rgba(0,0,0,0.15)",
                        transition: "0.2s",
                    }}
                    onMouseOver={(e) => {
                        if (currentIndex !== projetsClients.length - 1)
                            e.target.style.backgroundColor = "#1e4fcf";
                    }}
                    onMouseOut={(e) => {
                        if (currentIndex !== projetsClients.length - 1)
                            e.target.style.backgroundColor = "#2563eb";
                    }}
                >
                    Projet suivant ▶
                </button>
            </div>


            {/* Indicateur */}
            <p style={{ marginBottom: "20px", fontSize: "16px", opacity: 0.8 }}>
                Projet {currentIndex + 1} / {projetsClients.length}
            </p>

            {/* ProjectCard */}
            <ProjectCard
                project={currentProject}
                isAdmin={true}
                onReject={async () => {
                    try {
                        await dispatch(refuseProjet(token, currentProject.idProjetClient));
                        // Re-fetch la liste pour rester synchro avec le back
                        const projets = await dispatch(fetchProjetsClients(token));

                        // Met à jour l'index pour éviter d'être hors limite
                        setCurrentIndex(prev => {
                            const newIndex = Math.min(prev, projets.length - 1);
                            return newIndex < 0 ? 0 : newIndex;
                        });
                    } catch (err) {
                        console.error(err);
                    }
                }}
            />


        </div>
    );
};

export default ProjetsClientsAdminDashboard;
